import type { ReactNode } from 'react';

import { AlertCircle } from '../Icons';
import { joinClassNames } from './themeClassNames';

export function ErrorNotice({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  if (!children) return null;

  return (
    <div
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
      className={joinClassNames(
        'brand-error flex items-start gap-2 rounded-xl border-0 px-3 py-2.5 text-left text-sm',
        className,
      )}
    >
      <AlertCircle className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
      <div className="min-w-0 flex-1">{children}</div>
    </div>
  );
}
